import { render, staticRenderFns } from "./zhuanti.vue?vue&type=template&id=f83ae978&scoped=true"
import script from "./zhuanti.vue?vue&type=script&lang=js"
export * from "./zhuanti.vue?vue&type=script&lang=js"
import style0 from "./zhuanti.vue?vue&type=style&index=0&id=f83ae978&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83ae978",
  null
  
)

export default component.exports